const CRM_NUMERIC_FIELDS = new Set([
  'id', 'contactId', 'companyId', 'branchId', 'leadId', 'dealId', 'synergyId',
  'stageId', 'assignedToId', 'createdBy', 'createdById', 'userId', 'taskId',
  'meetingId', 'emailId', 'accountId', 'entityId', 'representedCompanyId',
  'parentCompanyId', 'primaryContactId', 'sectorId', 'pipelineStageId',
  'taskValue', 'dealValue', 'myValue', 'myPercentage', 'myNetValue',
  'synergyFees', 'commissionValue', 'commissionBaseAmount',
  'employeeCount', 'annualRevenue', 'foundedYear', 'pointsOfSale',
  'probability', 'duration', 'limit', 'offset', 'page',
]);

function normalizeValue(key: string, value: unknown): unknown {
  if (!CRM_NUMERIC_FIELDS.has(key)) return normalizeCrmNumericPayload(value);
  if (value === '' || value === undefined) return value;
  if (value === null || typeof value === 'number') return value;
  if (typeof value !== 'string') return value;
  const normalized = value.trim().replace(',', '.');
  if (!normalized) return value;
  const parsed = Number(normalized);
  return Number.isFinite(parsed) ? parsed : value;
}

export function normalizeCrmNumericPayload<T>(payload: T): T {
  if (Array.isArray(payload)) {
    return payload.map((item) => normalizeCrmNumericPayload(item)) as T;
  }
  if (!payload || typeof payload !== 'object' || payload instanceof Date || payload instanceof FormData) {
    return payload;
  }
  return Object.fromEntries(
    Object.entries(payload as Record<string, unknown>).map(([key, value]) => [key, normalizeValue(key, value)]),
  ) as T;
}
